import { call, put, select } from "redux-saga/effects";
import { readConferenceParticipantsSaga } from "../readConferenceParticipants/readConferenceParticipants";
import { selectCallSessions, setCallSessions } from "../../../state/callSessions/callSessionsSlice";
import { selectDevice } from "../../../state/device/deviceSlice";
export function* updateConferenceParticipantListSaga(action) {
    try {
        const { conferenceUri } = action.payload;
        const { DeviceUser } = yield select(selectDevice);
        const participants = yield call(readConferenceParticipantsSaga, { payload: { conferenceUri } });
        if (!participants || participants.length === 0) {
            console.debug('No participants found for conference:', conferenceUri);
            return;
        }

        const callSessions = yield select(selectCallSessions);
        const updatedCallSessions = callSessions.map(session => {
            if (session.isConference && session.session.remoteIdentity.uri.toString() === conferenceUri) {
                // Filter out the current user and map to participant_match
                const filteredParticipants = participants
                    .filter(participant => !participant.participant_match.includes(`sip:${DeviceUser}@`))
                    .map(participant => ({
                        participant_match: participant.participant_match,
                        mode: participant.mode
                    }));

                // Replace the existing conferenceList with the new filtered list
                session.conferenceList = filteredParticipants;
            }
            return session;
        });

        yield put(setCallSessions(updatedCallSessions));


    } catch (error) {
        console.error('Error updating conference participant list', error);
    }


}